import addError from '../../../utils/error.jsx';

export function request(accountId, id) {
    return {
        type: 'TRANSACTIONS_ASSIGN_REQUEST',
        accountId,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'TRANSACTIONS_ASSIGN_ERROR',
        errors,
        id
    };
}

export function finish(id, transaction) {
    return {
        type: 'TRANSACTIONS_ASSIGN_FINISH',
        transaction,
        id
    };
}
